import { isProd, isDev } from "@/config/constants";

const ACCOUNT_BASE_URL = isProd
  ? "https://infleet-api.maersk-digital.net/api/"
  : isDev
  ? "https://infleet-api.dev.maersk-digital.net/api/"
  : "http://localhost:8081/api/";

const ACCOUNT_BASE_BOT_URL = isProd
    ? "https://infleet-bot-api.maersk-digital.net/infleet/"
    : isDev
        ? "https://infleet-bot-api.dev.maersk-digital.net/infleet/"
        : "http://localhost:8081/infleet/";

//User Details
export const authorizeUser = `${ACCOUNT_BASE_URL}authorizeUser`;
export const addUsers = `${ACCOUNT_BASE_URL}addUsers`;
export const registerUser = `${ACCOUNT_BASE_URL}registerUser`;
export const deleteUsers = `${ACCOUNT_BASE_URL}deleteUsers`;
export const approveUser = `${ACCOUNT_BASE_URL}approveUser`;
export const editUser = `${ACCOUNT_BASE_URL}editUser`;
export const getAllUsers = `${ACCOUNT_BASE_URL}getAllUsers`;
export const getAllUsersToBeApproved = `${ACCOUNT_BASE_URL}getAllUsersToBeApproved`;
export const saveUserActivity = `${ACCOUNT_BASE_URL}saveUserActivity`;

export const addScenario = `${ACCOUNT_BASE_URL}addScenario`;
export const deleteScenario = `${ACCOUNT_BASE_URL}deleteScenario`;
export const getAllScenario = `${ACCOUNT_BASE_URL}getAllScenario`;
export const get2040splitPercentages = `${ACCOUNT_BASE_URL}get2040splitPercentages`;
export const getForecastVolumeAdjustments = `${ACCOUNT_BASE_URL}getForecastVolumeAdjustments`;
export const saveFinalPostings = `${ACCOUNT_BASE_URL}saveFinalPostings`;

export const getOutFleetReDelivery = `${ACCOUNT_BASE_URL}getOutfleetDetails/REDELIVERY`;
export const getOutFleetLost = `${ACCOUNT_BASE_URL}getOutfleetDetails/LOST`;
export const getOutFleetSold = `${ACCOUNT_BASE_URL}getOutfleetDetails/SOLD`;
export const saveOutFleetReDelivery = `${ACCOUNT_BASE_URL}saveOutfleetDetails/REDELIVERY`;
export const saveOutFleetLost = `${ACCOUNT_BASE_URL}saveOutfleetDetails/LOST`;
export const saveOutFleetSold = `${ACCOUNT_BASE_URL}saveOutfleetDetails/SOLD`;
export const saveInfleet = `${ACCOUNT_BASE_URL}saveInfleet`;

export const calculateTurnTime = `${ACCOUNT_BASE_URL}calculateTurnTime`;
export const getStocks = `${ACCOUNT_BASE_URL}getStock`;
export const saveStocks = `${ACCOUNT_BASE_URL}saveStock`;
export const getInfleet = `${ACCOUNT_BASE_URL}getInfleet`;
export const getPurchaseLease = `${ACCOUNT_BASE_URL}getPurchaseLease`;
export const savePurchaseLease = `${ACCOUNT_BASE_URL}savePurchaseLease`;
export const getInfleetLegacy = `${ACCOUNT_BASE_URL}getInfleetLegacy`;
export const saveTurnTimePosting = `${ACCOUNT_BASE_URL}saveTurnTimePosting`;
export const getBhUtilization = `${ACCOUNT_BASE_URL}getBhUtilization/`;
export const getSEPEvaluation = `${ACCOUNT_BASE_URL}getSEPEvaluation/`;
export const getPurchaseLeasePerc = `${ACCOUNT_BASE_URL}getPurchaseLeasePerc`;
export const getPurchaseLeasePercClone = `${ACCOUNT_BASE_URL}viewPurchaseLeasePercClone`;
export const getPurchaseLeaseVol = `${ACCOUNT_BASE_URL}getPurchaseLeaseVol`;

//View APIS
export const view2040splitPercentages = `${ACCOUNT_BASE_URL}view2040splitPercentages`;
export const viewForecastVolumeAdjustments = `${ACCOUNT_BASE_URL}viewForecastVolumeAdjustments`;
export const viewOutfleetLostDetails = `${ACCOUNT_BASE_URL}viewOutfleetDetails/LOST`;
export const viewOutfleetSoldDetails = `${ACCOUNT_BASE_URL}viewOutfleetDetails/SOLD`;
export const viewOutfleetReDeliveryDetails = `${ACCOUNT_BASE_URL}viewOutfleetDetails/REDELIVERY`;
export const viewTurnTimePosting = `${ACCOUNT_BASE_URL}viewTurnTimePosting`;
export const viewPurchaseLeasePerc = `${ACCOUNT_BASE_URL}viewPurchaseLeasePerc`;
export const viewPurchaseLeaseVol = `${ACCOUNT_BASE_URL}viewPurchaseLeaseVol`;
export const viewInfleet = `${ACCOUNT_BASE_URL}viewInfleetDetails`;
export const viewPurchaseLeaseVolNew = `${ACCOUNT_BASE_URL}viewPurchaseLeaseVolNew`;
export const getCombinedExcelDownload = `${ACCOUNT_BASE_URL}getCombinedExcelDownload`;

//actualVsForecast
export const summaryOutfleetLost = `${ACCOUNT_BASE_URL}getActualVsForecastOutfleet/LOST`;
export const summaryOutfleetSold = `${ACCOUNT_BASE_URL}getActualVsForecastOutfleet/SOLD`;
export const summaryOutfleetReDelivery = `${ACCOUNT_BASE_URL}getActualVsForecastOutfleet/REDELIVERY`;
export const getActualVsForecastInfleet = `${ACCOUNT_BASE_URL}getActualVsForecastInfleet`;
export const getActualVsForecastVolume = `${ACCOUNT_BASE_URL}getActualVsForecastVolume`;

//reports
export const getYearWiseSplitVols = `${ACCOUNT_BASE_URL}getYearWiseSplitVols`;
export const getTTAvgYearMonth = `${ACCOUNT_BASE_URL}getTTAvgYearMonth`;
export const getTTAvgContainerTypeSplit = `${ACCOUNT_BASE_URL}getTTAvgContainerTypeSplit`;

//summary
export const viewTTContainerSplit = `${ACCOUNT_BASE_URL}viewTTContainerSplit`;

//userPage
export const publishScenario = `${ACCOUNT_BASE_URL}publishScenario`;

//Chat Bot
export const chatBot = `${ACCOUNT_BASE_BOT_URL}chatBot`;















